import apiClient from './api_client_requests';

export default (config) => {
    return async (payload) => {
        let result = await apiClient(config).apiMethod({
            method: 'GetSweepsNoAuth',
            headers: {},
            args: {
                ...payload,
            },
        });

        return result;
    };
};
